import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { History } from 'history';


/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
export default class TelemetriaServiceUtil
{

  static reactPlugin: ReactPlugin;
  public static appInsights: ApplicationInsights;
  
  /**
   * Initialize the Application Insights class
   * @param {string} instrumentationKey - Application Insights Instrumentation Key
   * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
   * @return {void}
   */
  constructor (instrumentationKey: string, browserHistory: History) {
    if (!browserHistory) {
      throw new Error('Could not initialize Telemetry Service');
    }
    if (!instrumentationKey) {
      throw new Error('Instrumentation key not provided in ./src/telemetry-provider.jsx');
    }

    TelemetriaServiceUtil.reactPlugin = new ReactPlugin();

    TelemetriaServiceUtil.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        maxBatchInterval: 0,
        disableFetchTracking: false,
        extensions: [TelemetriaServiceUtil.reactPlugin],
        extensionConfig: {
          [TelemetriaServiceUtil.reactPlugin.identifier]: {
            history: browserHistory,
          },
        },
      },
    });

    TelemetriaServiceUtil.appInsights.loadAppInsights();
  };
};
